module.exports = __webpack_public_path__ + "static/profile-a4fa4d1660468a7269093bc5e13e2490.jpg";